import { VaroAdvanceProductsResultTypenames } from '@varo/graphql-schema-types';

export enum NavigationDecisionType {
  CRA_UPGRADE = 'CRA_UPGRADE',
  ELIGIBILITY = 'ELIGIBILITY',
  NONE = 'NONE',
}

type GetNavigationDecisionContext = {
  craUpgrade: {
    hasPermissionRequired: boolean;
    shouldAttemptCraUpgrade: boolean;
  };
  eligibility: {
    fetchingEligibilityStatus: boolean;
    hasError: boolean;
    isFinalEligibilityStatus: boolean;
    status: VaroAdvanceProductsResultTypenames | null;
  };
};

export const getNavigationDecision = ({
  craUpgrade,
  eligibility,
}: GetNavigationDecisionContext): NavigationDecisionType => {
  if (craUpgrade.hasPermissionRequired && craUpgrade.shouldAttemptCraUpgrade) {
    return NavigationDecisionType.CRA_UPGRADE;
  }

  const shouldNavigateToEligibilityFlow =
    eligibility.isFinalEligibilityStatus &&
    Boolean(eligibility.status) &&
    !eligibility.fetchingEligibilityStatus &&
    !eligibility.hasError;

  if (shouldNavigateToEligibilityFlow) {
    return NavigationDecisionType.ELIGIBILITY;
  }

  return NavigationDecisionType.NONE;
};
